module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0004"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0005"
    }
  }, [_vm._v("CHAPTER ONE: TURNABOUT")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0006"
    }
  }, [_vm._v("CHAPTER TWO: BOBBY DEPARTS")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007"
    }
  }, [_vm._v("CHAPTER THREE: ALIBI")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0008"
    }
  }, [_vm._v("CHAPTER FOUR: ZELLNER FACTOR")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0009"
    }
  }, [_vm._v("CHAPTER FIVE: SKINNY")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX: AVERY’S PHONE CALL")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN: COMPUTER BLUES")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT: BOBBY'S OBSESSIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE: SHADY DEPARTMENT")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN: RAV4")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN: BATHROOM SINK")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE: BLOOD DOCTOR")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN: TWO CARS")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN: CANINE NOSES")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN: COVER UP")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN: NOTHING THERE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN: EVIDENCE PILE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN: HOSPITAL STOP")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINETEEN: SECOND TRY")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY: GARAGE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-ONE: HEROES OR GOATS?")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-TWO: THE CRIME")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-THREE: KEN KRATZ")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-FOUR: CREEPY KRATZ")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-FIVE: COMPUTER DISK")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-SIX: FANTASY LIFE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-SEVEN: DAMAGED")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-EIGHT: AVERY’S BRAIN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-NINE: BOBBY’S GARAGE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4176b331","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0003.vue
// module id = 69
// module chunks = 0